<template>
  <div class="view-container" v-if="me">
    <div class="width-100">
      <v-row no-gutters class="mt-10 mb-10">
        <v-col cols="12" class="text-center">
          <v-avatar color="primary" size="100">
            <span class="font--black font--m-1">{{ me.storeSet[0].name[0] }}</span>
          </v-avatar>
          <p class="font--m-1 mt-5">{{ me.storeSet[0].name }}</p>
          <!-- <v-chip label color="#F1F994" v-if="me.planChoice">
            {{ me.planChoice.plan.name }} 구독중
          </v-chip> -->
          <v-chip
            small
            color="pink lighten-4"
            text-color="black"
            :to="{ path: '/my/plans' }"
            v-if="me.planChoice"
          >
            {{ me.planChoice.plan.name }}
          </v-chip>
          <!-- <v-btn icon color="black" large :to="{ name: 'my/plans' }">
            <v-icon>mdi-pencil-box-outline</v-icon>
          </v-btn> -->
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" class="mb-10">
          <v-divider class="mb-5"></v-divider>
          <p class="color--gray-80 font--m-5">회사명</p>
          <p class="font--m-9">{{ me.storeSet[0].name }}</p>
          <v-divider class="mb-5"></v-divider>
          <p class="color--gray-80 font--m-5">사업장주소</p>
          <p class="font--m-9">{{ me.storeSet[0].address1 }}</p>
          <p class="font--m-9">{{ me.storeSet[0].address2 }}</p>
          <template v-if="me.bankAccountSet.length > 0">
            <v-divider class="mb-5"></v-divider>
            <p class="color--gray-80 font--m-5">계좌 정보</p>
            <p class="font--m-9">
              {{ me.bankAccountSet[me.bankAccountSet.length - 1].bank | bankCodeName }}
            </p>
            <p class="font--m-9">{{ me.bankAccountSet[me.bankAccountSet.length - 1].number }}</p>
            <p class="font--m-9">
              {{ me.bankAccountSet[me.bankAccountSet.length - 1].holderName }}
            </p>
          </template>
          <v-divider class="mb-5"></v-divider>
          <p class="color--gray-80 font--m-5">연락처</p>
          <p class="font--m-9">{{ me.phone }}</p>
          <v-divider class="mb-5"></v-divider>
          <v-row class="mb-5" no-gutters>
            <v-col cols="4">
              <v-chip small color="yellow">
                <router-link
                  class="color--black"
                  :to="{ name: 'my/contract/management' }"
                  id="btn__nZeqDP5HdUe7cxdArNihPg=="
                >
                  계약서관리
                </router-link>
              </v-chip>
            </v-col>
          </v-row>
          <v-divider class="mb-5"></v-divider>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState('auth', ['me']),
  },
  created() {
    this.getMe()
  },
  methods: {
    ...mapActions('auth', ['getMe']),
  },
}
</script>
<style lang="scss" scoped>
.v-chip {
  a {
    text-decoration: none;
  }
}
</style>
